import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const FollowUp: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-neutral-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-12 h-12 fill-white"
                        >
                            <path d="M11.25 7C10.8281 7 10.5 7.35156 10.5 7.75C10.5 8.99219 9.46875 10 8.25 10H4.5V9.0625C4.5 8.85156 4.35938 8.64062 4.14844 8.57031C3.96094 8.47656 3.72656 8.5 3.53906 8.66406L1.66406 10.3516C1.54688 10.4453 1.5 10.6094 1.5 10.75C1.5 10.9141 1.54688 11.0781 1.66406 11.1719L3.53906 12.8594C3.65625 12.9531 3.79688 13 3.9375 13C4.00781 13 4.07812 13 4.14844 12.9531C4.35938 12.8828 4.5 12.6719 4.5 12.4375V11.5H8.25C10.3125 11.5 12 9.83594 12 7.75C12 7.35156 11.6484 7 11.25 7ZM3.75 4H7.47656L7.5 4.9375C7.5 5.17188 7.61719 5.38281 7.82812 5.45312C7.89844 5.5 7.96875 5.5 8.03906 5.5C8.15625 5.5 8.29688 5.45312 8.41406 5.35938L10.2891 3.67188C10.4297 3.57812 10.5 3.41406 10.5 3.25C10.5 3.0625 10.4297 2.92188 10.3125 2.82812L8.4375 1.14062C8.27344 0.976562 8.01562 0.953125 7.82812 1.04688C7.61719 1.14062 7.47656 1.35156 7.47656 1.5625L7.5 2.5H3.75C1.66406 2.5 0 4.1875 0 6.25C0 6.67188 0.328125 7 0.75 7C1.14844 7 1.5 6.67188 1.5 6.25C1.5 5.03125 2.50781 4 3.75 4Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">{sectionName || 'Follow Up'}</div>} key="1">
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    followup_in_unbold: !rxConfig?.followup_in_unbold,
                                });
                            }}
                        >
                            <span>Make the follow up date bold</span>
                            <Checkbox checked={!rxConfig?.followup_in_unbold}></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.followup_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        followup_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            followup_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.followup_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        followup_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            followup_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Date</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={
                                    rxConfig?.followup_date_color ||
                                    rxConfig?.followup_properties_color ||
                                    '#000000'
                                }
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        followup_date_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            followup_date_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default FollowUp;
